import { generateTestId } from "@client-shared";

export const setOnboardingStepperTestId = (identifier: string): string =>
  generateTestId("OnboardingStepper", identifier);
